import BrainSearchSidebarHeader from "@/brain-search/internal/BrainSearchSidebarHeader"
import BrainSearchSidebarList from "@/brain-search/internal/BrainSearchSidebarList"
import { useActiveOrganization } from "@/core/context/ActiveOrganizationContext"
import { useGlobalDrawer } from "@/core/context/GlobalDrawerProvider"
import ROUTE_NAMES from "@/core/route/util/routeNames"
import makeUseStyles from "@assets/style/util/makeUseStyles"
import ScrollShadowContainer from "@components/scroll-shadow/ScrollShadowContainer"
import { DiscoIcon, DiscoSideBar, DiscoSideBarItem, DiscoSideBarProps } from "@disco-ui"
import usePermissions from "@utils/hook/usePermissions"

export default function BrainSearchSidebar(props: Partial<DiscoSideBarProps>) {
  const classes = useStyles()
  const drawer = useGlobalDrawer("brainSearch")
  const activeOrganization = useActiveOrganization()!
  const permissions = usePermissions(activeOrganization)
  const canManageBrainSearchSettings = permissions.has("organization_settings.manage")

  return (
    <DiscoSideBar
      {...props}
      fullHeight
      data-testid={"BrainSearchSidebar"}
      header={<BrainSearchSidebarHeader />}
      items={
        <div>
          <ScrollShadowContainer classes={{ scrollContainer: classes.itemsContainer }}>
            {/* New Conversation */}
            <DiscoSideBarItem
              name={"New Conversation"}
              onClick={() => drawer.setParams({ convId: undefined })}
              leftIcon={<DiscoIcon icon={"edit"} />}
              selected={!drawer.params.convId}
            />

            {/* Conversations */}
            <BrainSearchSidebarList />
          </ScrollShadowContainer>
        </div>
      }
      adminActions={
        canManageBrainSearchSettings ? (
          <DiscoSideBarItem
            leftIcon={<DiscoIcon icon={"settings"} />}
            name={"Settings"}
            to={{
              pathname: ROUTE_NAMES.ADMIN.AI.ROOT,
              search: "?openAskSettings=1",
            }}
            // Don't show selected when the page behind drawer is the settings page
            selected={false}
          />
        ) : undefined
      }
    />
  )
}

const useStyles = makeUseStyles((theme) => ({
  itemsContainer: {
    flex: "auto",
    display: "inline-flex",
    flexFlow: "column",
    flexShrink: 0,
    minHeight: "100%",
    alignItems: "center",
    width: "100%",
    padding: theme.spacing(2),
  },
}))
